import Vue from 'vue'
import VueRouter from 'vue-router'
import reportMixin from '@/mixin/reportMixin.js'
import Home from '@/pages/home.vue'
import About from '@/pages/about.vue'
import Services from '@/pages/services.vue'

// 全局混入reportMixin，使所有组件都具有页面浏览上报功能
Vue.mixin(reportMixin)
Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/services',
		name: 'Services',
		component: Services,
	},
	{
		path: '/about',
		name: 'About',
		component: About,
	},
	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			if (to.hash) {
				return {
					selector: to.hash,
					behavior: 'smooth',
				}
			}
			return { x: 0, y: 0 }
		},
	})
}
